'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function LoanOfferReupRequest() {
  this.extends = [_LoanOfferReupController, _AnalyticsData, _Routes];
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this._hist = new History();
  this._analytics = new Analytics();
  this.successUrl = '/member/dashboard/loans/preapproval';

  this.init = function () {
    this._super();
    this.$node = $(this.node);
    this._notification = $('#Notification');
    this._submitButton = $('.js-preapproval-request-submit', this.node);

    this._extendCustomValidations();
    this._extendViewMap();

    this._createLoanRequestCallback = this.presenter.addCallbackToAction('account.edit_credit_info', this._onEditCreditRequest.bind(this));
    this._onCreditCheckCallback = this.presenter.addCallbackToAction('money.offers.get_credit_detail', this._onGetCreditDetail.bind(this));
    this._onGetAccountCallback = this.presenter.addCallbackToAction('account.self', this._onAccountModelUpdate.bind(this));

    // Add event listener to analytics
    this.$node.find('#js--score-info').on('mouseover', this.pushTooltipAnalytics.bind(this));
  };

  this.initAllReady = function () {
    this._super();
    this._analytics.pushEvent('virtual-page-view');
  };

  this.initPage = function () {
    this._super();
    if ($('#tray-navigation').mogo() && !$('#tray-navigation').mogo().isCompleted(0)) {
      this._hist.goToUrl('/member/dashboard/loans/request/review-info');
      return;
    }

    this.node.removeClass('reupPreapproval--loading');
  };

  this._onEditCreditRequest = function (data, response) {
    if (response == 500 && data.errors[0].key == 'equifax_remote_service_error') {
      this.handleDeclinedState(data, response);
    } else if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({ action: 'account.edit_credit_info' }, { productLabel: 'MogoMember' });
    } else if (response == 200) {
      if (this.presenter.hasAction('money.offers.get_credit_detail')) {
        var formAnalyticsID = $('#choosePreApprovedAmt').data('analytics-id');
        this._analytics.pushEvent('form-submit', {
          FormID: [formAnalyticsID],
          LTV: [this.presenter.getModelProperty('account.life_time_value')]
        });
        var analyticsData = this._analytics.constructData('Loan Offer Refresh Submitted');
        var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
        analyticsRequest.send();
        this.presenter.performAction('money.offers.get_credit_detail');
      } else {
        console.error('LoanOfferReupRequest: No permision money.offers.get_credit_detail');
        // Redirect
        this._hist.replaceUrl(this.paths.loans.preapproval);
        return;
      }
      this._setButtonLoadState(true); // not finished processing
    } else {
      if (data.errors) {
        $('#choosePreApprovedAmt', this.node).mogo().parseErrorObject(data.errors);
      }
      this._notification.mogo().get();
    }
  };

  this._onGetCreditDetail = function (data, response) {
    if (response == 500 && data.errors[0].key == 'equifax_remote_service_error') {
      this.handleDeclinedState(data, response);
    } else if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({ action: 'money.offers.get_credit_detail' }, { productLabel: 'MogoMember' });
    } else if (response == 200) {
      this._onApprovedProductLoad(data);
    } else {
      if (data.errors) {
        console.warn(data.errors);
      }
      this._notification.mogo().get();
    }
  };

  this._onApprovedProductLoad = function (data) {
    var _this = this;

    var isTrustSciencePending = data.credit_check_decision === 'trust_science_pending';
    if (isTrustSciencePending) {
      this.presenter.setModelProperty('account.credit_check_decision', 'trust_science_pending');
    } else {
      this.successUrl += '?notification=reup-preapproval';
    }

    // hammer away at some endpoints in case there's unknown race conditions, dependencies, caching issues at play
    try {
      this.presenter.updateModel('money.offers', null, function (data) {
        _this._parseLoanOffers(data);
        if (_this.presenter.models.money.loans) {
          _this.presenter.updateModel('money.loans', null, function () {
            if (_this.presenter.models.money.offers) {
              _this.presenter.updateModel('money.offers', null, function () {
                if (_this.presenter.models.money.applications) {
                  _this.presenter.updateModel('money.applications', null, function () {
                    _this.presenter.updateModel('account', null, function () {
                      // _onAccountModelUpdate action callback is called...
                    });
                  });
                } else {
                  _this.presenter.createModel('money.applications');
                  _this.presenter.updateModel('account', null, function () {
                    // _onAccountModelUpdate action callback is called...
                  });
                }
              });
            } else {
              _this.presenter.updateModel('account', null, function () {
                // _onAccountModelUpdate action callback is called...
              });
            }
          });
        }
      });
    } catch (e) {
      this.presenter.updateModel('account', null, function () {
        // _onAccountModelUpdate action callback is called...
      });
    }
  };

  this._onAccountModelUpdate = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({ action: 'account.self' }, { productLabel: 'MogoMember' });
    } else if (response == 200) {
      setTimeout(this._hist.goToUrl.bind(this, this.successUrl), 1000); // delay to give BE bit more time to sync up services...
    } else {
      if (data.errors) {
        console.warn(data.errors);
      }
      this._notification.mogo().get();
    }
  };

  this._extendCustomValidations = function () {
    this.presenter.extendCustomValidations('account.edit_credit_info', {
      requested_credit_amount: {
        sanitize: function sanitize(value) {
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
            return value;
          }
          return Number(value);
        }
      }
    });
  };

  this._extendViewMap = function () {
    var viewMap = {
      'account.requested_credit_amount': {
        set: function set(value) {
          return Number(value);
        }
      }
    };
    this.presenter.extendViewMap(viewMap);
  };

  this._setButtonLoadState = function (disabled) {
    if (disabled) {
      this._submitButton.mogo().setDisabledLoadState();
    } else {
      this._submitButton.mogo().removeDisabledLoadState();
    }
  };

  this.pushTooltipAnalytics = function () {
    this.analytics.pushEvent('tooltip', { tooltipContent: ['Credit Check Consent'] });
  };

  this.destroy = function () {
    this.presenter.removeCallbackFromAction('account.edit_credit_info', this._createLoanRequestCallback);
    this.presenter.removeCallbackFromAction('money.offers.get_credit_detail', this._onCreditCheckCallback);
    this.presenter.removeCallbackFromAction('account.self', this._onGetAccountCallback);

    // delete existing models to reduce chance of a stale state later on
    // yes we just updated them all but hey
    if (this.presenter.models.money.offers) delete this.presenter.models.money.offers;
    if (this.presenter.models.money.applications) delete this.presenter.models.money.applications;
    if (this.presenter.models.money.loans) delete this.presenter.models.money.loans;

    this._super();
  };
}